var _g, _path, _g2, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2343_8543)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 22.5,
    r: 22.5,
    fill: "#1A1A24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 22.5,
    r: 22,
    stroke: "#747480",
    strokeOpacity: 0.21
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1422 12.7324C18.7423 12.7324 12.7436 18.7312 12.7436 26.1311V28.4014C12.7434 28.4193 12.7433 28.4372 12.7433 28.4551C12.7433 31.2791 15.0326 33.5684 17.8566 33.5684H34.4273C37.2513 33.5684 39.5406 31.2791 39.5406 28.4551C39.5406 28.4538 39.5406 28.4524 39.5406 28.451H39.5409V26.1311C39.5409 18.7312 33.5421 12.7324 26.1422 12.7324Z",
    fill: "#FFE600"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2343_8543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4492 13.7766C22.4492 12.6784 23.3395 11.7881 24.4377 11.7881H27.8466C28.9448 11.7881 29.8351 12.6784 29.8351 13.7766H22.4492Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7634,
    y: 7.24219,
    width: 0.804867,
    height: 4.54513,
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1422,
    cy: 6.71983,
    r: 0.994247,
    fill: "#FFE600"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.9626 25.3322C15.9626 21.985 18.6761 19.2715 22.0234 19.2715H30.1656C33.5129 19.2715 36.2264 21.985 36.2264 25.3322C36.2264 26.4301 35.3363 27.3202 34.2384 27.3202H17.9506C16.8527 27.3202 15.9626 26.4301 15.9626 25.3322Z",
    fill: "#1A1A24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.8871 24.533C15.8871 28.8894 19.4186 32.4209 23.775 32.4209H28.2737C32.63 32.4209 36.1616 28.8894 36.1616 24.533C36.1616 23.1041 35.0032 21.9457 33.5743 21.9457H18.4743C17.0454 21.9457 15.8871 23.1041 15.8871 24.533Z",
    fill: "#1A1A24"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0466,
    cy: 23.6498,
    r: 2.20155,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1178,
    cy: 23.7181,
    r: 1.79911,
    fill: "#1A1A24"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4858,
    cy: 23.6469,
    r: 2.20155,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5566,
    cy: 23.7181,
    r: 1.79911,
    fill: "#1A1A24"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 22.6148,
    cy: 22.894,
    r: 0.733849,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 29.0537,
    cy: 22.894,
    r: 0.733849,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2343_8543",
    x: 0,
    y: 0,
    width: 53,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2343_8543"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2343_8543",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2343_8543",
    x: 16.4492,
    y: 3.72559,
    width: 19.3859,
    height: 20.0508,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2343_8543"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2343_8543",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotUser);
export default __webpack_public_path__ + "static/media/bot-user.9e30115447c5fd158882be22b9e87388.svg";
export { ForwardRef as ReactComponent };